import { Module } from "wrapper6";
import { setCookie, getCookie } from '../utils/_cookies'

export default class MorningcatchButton extends Module {
    ready () {
        if (getCookie('hideMorningcatch') === 'true' && window.enableMorningcatchClose === true) {
            return
        }

        window.onMorningCatchReady = (note) => {
            const button = note.element.querySelector('.mt-trigger')
            const closeButton = this.createCloseButton(button)

            if (window.enableMorningcatchClose === false) {
                button.classList.add('show')
                return
            }

            button.appendChild(closeButton)
            button.classList.add('show')
        };
    }

    createCloseButton (button) {
        const buttonEl = document.createElement('div')

        buttonEl.classList.add('mtt-trigger-close')
        buttonEl.addEventListener('click', () => {
            setCookie('hideMorningcatch', 'true', 1)
            button.classList.remove('show')
        })

        return buttonEl
    }
}